import React from 'react';
import readingTime from 'reading-time';
import styled from 'styled-components';

import Clock from '../../icons/clock.svg';

const ContentTitle = (props) => {
  const { author, date, title, body } = props;

  let timeEstimate = '';

  if (body) {
    timeEstimate = readingTime(body);
  }

  return (
    <>
      <Title>{title}</Title>
      <MetaData>
        {author && (
          <Author>
            {author}
            <Estimate>
              <Clock /> {Math.ceil(timeEstimate.minutes)} min
            </Estimate>
          </Author>
        )}
        <PublishDate>{date}</PublishDate>
      </MetaData>
    </>
  );
};

const Title = styled.h1`
  color: var(--blue-dark);
  font-size: var(--heading-size-xl);
  font-weight: var(--font-weight-black);
  line-height: var(--line-height-sm);
  margin-bottom: 15px;
`;

const Author = styled.p`
  display: block;
  color: var(--gray-dark);
  font-size: var(--font-size-sm);
`;

const PublishDate = styled.small`
  color: var(--gray-dark);
  font-size: var(--font-size-sm);
  margin-top: 5px;
`;

const MetaData = styled.div`
  margin-bottom: 40px;
`;

const Estimate = styled.span`
  margin-left: 11px;
  color: var(--gray-dark);

  svg {
    transform: translateY(1px);
    path {
      fill: var(--gray-dark);
    }
  }
`;

export default ContentTitle;
